/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsChangeZakatDate204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsChangeZakatDate505Schema = z.any();

export const optionsChangeZakatDateMutationResponseSchema = z.lazy(() => optionsChangeZakatDate204Schema);
